import { ClientSideFilterableData } from '../types';

export const filterDataByTextMatch = <TData extends ClientSideFilterableData>(
  data: TData[],
  filterValues: Partial<Record<keyof TData, string | string[]>>,
): TData[] => {
  if (!filterValues || Object.keys(filterValues).length === 0) {
    return data;
  }

  const checkForMatch = (rowValue: unknown, filterValue: string | string[]) => {
    const rowValueStr = !rowValue ? '' : String(rowValue).toLowerCase();

    if (Array.isArray(filterValue)) {
      return filterValue.some(v => rowValueStr === String(v).toLowerCase());
    }

    return rowValueStr === filterValue.toLowerCase();
  };

  return data.filter(row =>
    Object.entries(filterValues).every(([filterKey, filterValue]) => {
      if (!filterValue) {
        return true;
      }

      return checkForMatch(row[filterKey], filterValue);
    }),
  );
};
